import { createElementBlock as l, openBlock as o, createElementVNode as r } from "vue";
const n = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
};
function t(c, e) {
  return o(), l("svg", n, e[0] || (e[0] = [
    r("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.223 2.225c.73.382 1.124 1.221.941 2.11-.318 1.554-.486 2.855-.322 4.05.056.402.15.8.296 1.195.325-.88.85-1.683 1.51-2.452.621-.726 1.53-.784 2.206-.52.66.258 1.251.868 1.375 1.704.08.537.18 1.075.282 1.634.154.836.32 1.726.412 2.62.155 1.478.122 3.048-.527 4.57-.697 1.637-1.696 2.865-2.98 3.68-1.28.81-2.771 1.167-4.384 1.184h-.01c-1.185 0-2.893-.23-4.443-1.15-1.591-.945-2.946-2.577-3.4-5.212-.411-2.389-.055-4.215.475-5.501.15-.363.403-.698.78-.9a1.54 1.54 0 0 1 1.174-.115c.71.212 1.178.855 1.323 1.549.08.379.198.744.383 1.111a12.7 12.7 0 0 1 .141-3.867c.324-1.686 1.294-3.51 2.49-5.115.573-.77 1.513-.975 2.278-.575",
      "clip-rule": "evenodd"
    }, null, -1)
  ]));
}
const i = { render: t };
export {
  i as default,
  t as render
};
//# sourceMappingURL=ic_fire_filled-7iw8Eoml.js.map
